
import { Check } from "lucide-react";

interface FutureSectionProps {}

const FutureSection = ({}: FutureSectionProps) => {
  return (
    <section className="px-4 py-16 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-3 text-corporate-primary-100">Looking Ahead</h2>
        <div className="w-24 h-1 bg-corporate-secondary-100 mx-auto mb-6"></div>
        <p className="text-corporate-neutral-75 text-center text-lg mb-12">
          At METRADE, we remain committed to offering a reliable, flexible, and user-friendly 
          platform that evolves with market conditions.
        </p>
        <div className="space-y-4 max-w-2xl mx-auto">
          <div className="text-corporate-neutral-75 flex items-center bg-white p-6 rounded-lg shadow-lg border-l-4 border-corporate-secondary-100 transform hover:scale-105 transition-transform duration-300">
            <Check className="w-6 h-6 text-corporate-primary-75 mr-4 flex-shrink-0" />
            <span>Expand integrations with additional reputable exchanges and verified strategists.</span>
          </div>
          <div className="text-corporate-neutral-75 flex items-center bg-white p-6 rounded-lg shadow-lg border-l-4 border-corporate-secondary-100 transform hover:scale-105 transition-transform duration-300">
            <Check className="w-6 h-6 text-corporate-primary-75 mr-4 flex-shrink-0" />
            <span>Enhance user experience through continuous product refinements.</span>
          </div>
          <div className="text-corporate-neutral-75 flex items-center bg-white p-6 rounded-lg shadow-lg border-l-4 border-corporate-secondary-100 transform hover:scale-105 transition-transform duration-300">
            <Check className="w-6 h-6 text-corporate-primary-75 mr-4 flex-shrink-0" />
            <span>Maintain our dedication to security, transparency, and performance.</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FutureSection;
